import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styles from './styles/TopBar.module.css';
import CanvasContext from '../../../context/CanvasContext';
import {
    FaEdit,
} from 'react-icons/fa';
import axios from 'axios';


const TopBar = ({renderEditSidebar, setRenderEditSidebar, isMobile}) => {

    const { 
        scenario, selectedNodeIds, onCanvasClick,
    } = useContext(CanvasContext);
    
    const { scenarioId } = useParams();

    const navigate = useNavigate();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    
    const isButtonDisabled = !selectedNodeIds || selectedNodeIds.length < 1;



    useEffect(() => {
        if (isButtonDisabled) {
            setIsDropdownOpen(false);
        }
    }, [isButtonDisabled, isDropdownOpen]);

    const toggleEditSidebar = () => {
        
        if (isMobile && renderEditSidebar) {
            
            setRenderEditSidebar(false);
            onCanvasClick();
        } else {
            
            setRenderEditSidebar(!renderEditSidebar);
        }
    };

    const handleShare = async (infoType, info) => {
        const user = await axios.get(`${process.env.REACT_APP_API_URL_LOCAL}/api/users/email/${info}/`);
        const uId = user.data._id;
        const response = await axios.post(`${process.env.REACT_APP_API_URL_LOCAL}/api/scenarios/${scenarioId}/add-collaborator/${uId}`)

        console.log("Addition status", response.data.message);

        const addRes = await axios.get(`${process.env.REACT_APP_API_URL_LOCAL}/api/scenarios/${scenarioId}/get-collaborators`);
        console.log("Current collaborators after addition", addRes.data.collaborators);
    };

    const handleRemove = async(infoType, info) => {
        const user = await axios.get(`${process.env.REACT_APP_API_URL_LOCAL}/api/users/email/${info}/`);
        const uId = user.data._id;
        const response = await axios.post(`${process.env.REACT_APP_API_URL_LOCAL}/api/scenarios/${scenarioId}/remove-collaborator/${uId}`);
        console.log("Removal status", response.data.message);

        const removeRes = await axios.get(`${process.env.REACT_APP_API_URL_LOCAL}/api/scenarios/${scenarioId}/get-collaborators`);
        console.log("Current collaborators after removal", removeRes.data.collaborators);
    };
    
    return (
        <>
            <div className={styles.container}>
                {/* Left Section */}
                <div className={styles.leftSection}>
                    <div className={styles.logoContainer}>
                        <img
                            className={styles.logo}
                            src={require('../../../images/logo_teal_background.png')}
                            alt="Home"
                            onClick={() => navigate('/home')}
                        />
                    </div>
                </div>
    
                {/* Middle Section */}
                <div className={styles.middleSection}>
                    <div className={styles.titleContainer}>
                        <h1>{scenario?.title || 'Untitled Scenario'}</h1>
                    </div>
                    <div>
                        <button onClick={() => handleShare('email','lindbergacc@gmail.com')}>Share</button>
                    </div>
                    <div>
                        <button onClick={() => handleRemove('email','lindbergacc@gmail.com')}>Remove</button>
                    </div>
                </div>

                
                {/* Right Section */}   
                <div className={styles.rightSection}>
                    <div
                        className={`${styles.item} ${renderEditSidebar ? styles.itemActive : ''}`}
                        onClick={toggleEditSidebar}
                        data-tooltip-id="tooltip"
                        data-tooltip-content="Edit Tools"
                    >
                        <FaEdit />
                    </div>
                </div>
            </div>
        </>
    );
    
}

export default TopBar;
